module.exports = __webpack_public_path__ + "static/img/company-9.da7d482b.png";